import Section from "./Section";
import qrcode from '../assets/qrcode.png';


function ContactPage(){
    return (
        <Section>
            <div className="d-section-center">
                <div className="d-section-text">
                    <h2>Feel free to contact me.</h2>
                    <img src={qrcode} alt=""/>
                </div>
                <div className="d-section-text">
                    <h1>Contact</h1>
                    <h3>My address</h3>
                    <p>Thomas Vaté</p>
                    <p>402 rue de la République</p>
                    <p>73000 Chambéry</p>
                    <h3>My phone number</h3>
                    <p>06 42 90 35 27</p>
                    <h3>My email</h3>
                    <p>thomasnou@orange.fr</p>
                </div>
            </div>
        </Section>
    );
}

export default ContactPage;